import { FilterModalTypes } from '../../../../../../components/FilterModal';

const riskRatingLabels = ['Muito baixo', 'Baixo', 'Médio', 'Alto', 'Muito alto'];

const riskRatingValues: {
  fixedIncome: string[];
  funds: string[];
} = {
  fixedIncome: ['RISCOMUITOBAIXO', 'RISCOBAIXO', 'RISCOMEDIO', 'RISCOALTO', 'RISCOMUITOALTO'],
  funds: ['VeryLowRisk', 'LowRisk', 'MediumRisk', 'HighRisk', 'VeryHighRisk'],
};

export const getRiskRatingLevelFilter = (
  type: 'fixedIncome' | 'funds'
): FilterModalTypes.FilterType => ({
  type: 'section',
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
  optionsColumns: 1,
  optionWidth: 'full',
  options: riskRatingValues[type].map((value, index) => ({
    label: riskRatingLabels[index],
    value,
  })),
});

export const profitabilityTypeFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Tipo',
  fieldName: 'profitabilityType',
  optionsColumns: 1,
  optionWidth: 'full',
  options: [
    { label: 'Prefixado', value: 'PRE' },
    { label: 'Pós fixado(CDI)', value: 'POS' },
    { label: 'Inflação', value: 'INFLACAO' },
  ],
};

export const dailyLiquidityFilter: FilterModalTypes.FilterType = {
  type: 'boolean',
  title: 'Liquidez',
  fieldName: 'dailyLiquidity',
  options: [{ label: 'Liquidez Diária', value: 'true' }],
};

export const taxExemptFilter: FilterModalTypes.FilterType = {
  type: 'boolean',
  title: 'IR',
  fieldName: 'taxExempt',
  optionsColumns: 1,
  optionWidth: 'full',
  options: [
    { label: 'Isento de IR', value: 'true' },
    { label: 'Tributável', value: 'false' },
  ],
};

export const applicationAmountFilterNew: FilterModalTypes.FilterType = {
  type: 'range',
  fieldName: 'applicationAmount',
  title: 'Qual o valor da aplicação',
  labelType: 'money',
  showHelperText: true,
  max: 10000000,
  min: 0,
};

export const applicationAmountFilter: FilterModalTypes.FilterType = {
  type: 'range',
  fieldName: 'applicationAmount',
  title: 'Investimento mínimo',
  labelType: 'money',
  max: 10000000,
  min: 0,
};

export const legacyAmountFilter: FilterModalTypes.FilterType = {
  type: 'range',
  fieldName: 'legacyAmount',
  title: 'Aplicação Mínima',
  labelType: 'money',
  max: 10000000,
  min: 0,
};

export const legacyInitialApplicationFilter: FilterModalTypes.FilterType = {
  type: 'range',
  fieldName: 'legacyInitialApplication',
  title: 'Aplicação Mínima',
  labelType: 'money',
  max: 10000000,
  min: 0,
};

export const privatePensionSettlementPeriodFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'privatePensionSettlementPeriod',
  title: 'Prazo',
  labelType: 'months',
  max: 720,
  min: 0,
  step: 10,
};

export const coesApplicationAmountFilter: FilterModalTypes.FilterType = {
  type: 'range',
  fieldName: 'applicationAmount',
  title: 'Valor de aplicação',
  labelType: 'money',
  max: 10000000,
  min: 0,
};

export const monthsToRedemptionFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'timeframeInMonths',
  title: 'Quando pretende resgatar?',
  labelType: 'months',
  max: 120,
  min: 0,
  step: 1,
};

export const daysToRedemptionFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'daysToRedemption',
  title: 'Escolha o vencimento',
  labelType: 'days',
  max: 120,
  min: 0,
  step: 1,
};

export const directTreasuryDaysToRedemptionFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'daysToRedemption',
  title: 'Escolha o vencimento',
  labelType: 'days',
  max: 36500,
  min: 0,
  step: 25,
};

export const redemptionDaysFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'redemptionDays',
  title: 'Resgate antecipado',
  labelType: 'days',
  max: 120,
  min: 0,
  step: 1,
};

export const deadlineMonthsFilter: FilterModalTypes.FilterType = {
  type: 'multiSlider',
  fieldName: 'deadlineMonths',
  title: 'Prazo',
  labelType: 'months',
  max: 720,
  min: 0,
  step: 10,
};

export const semiAnnualFilter: FilterModalTypes.FilterType = {
  type: 'boolean',
  fieldName: 'semiAnnual',
  title: 'Juros Semestrais',
  options: [
    { label: 'Sim', value: 'true' },
    { label: 'Não', value: 'false' },
  ],
};

export const isInvestorFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Público alvo',
  fieldName: 'isInvestor',
  optionsColumns: 1,
  optionWidth: 'full',
  options: [
    { label: 'Investidor qualificado', value: 'QUALIFIED_INVESTOR' },
    { label: 'Investidor profissional', value: 'PROFESSIONAL_INVESTOR' },
  ],
};

export const closedToApplicationDescriptionFilter: FilterModalTypes.FilterType = {
  type: 'boolean',
  title: 'Status',
  fieldName: 'closedToApplicationDescription',
  optionsColumns: 1,
  optionWidth: 'full',
  options: [{ label: 'Aberto para aplicação', value: 'true' }],
};

export const quotationRedemptionOrLiquidityTermFilter: FilterModalTypes.FilterType = {
  title: 'Cotização do resgate e liquidação',
  fieldName: 'quotationRedemptionOrLiquidityTerm',
  type: 'section',
  options: [
    { label: 'Até D+1', value: '1' },
    { label: 'Até D+5', value: '5' },
    { label: 'Até D+10', value: '10' },
    { label: 'Até D+30', value: '30' },
    { label: 'Maior que D+30', value: '31' },
  ],
};

export const coesRisk: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Classificação de risco',
  fieldName: 'riskRatingLevel',
  options: [
    { label: 'Alto', value: 'RISCOALTO' },
    { label: 'Muito Alto', value: 'RISCOMUITOALTO' },
  ],
};

export const marketOptionFilter: FilterModalTypes.FilterType = {
  type: 'boolean',
  fieldName: 'marketType',
  title: 'Mercado',
  options: [
    { label: 'Primário', value: 'Primary' },
    { label: 'Secundário', value: 'Secondary' },
  ],
  optionsColumns: 1,
  optionWidth: 'full',
};

export const indexersFilter: FilterModalTypes.FilterType = {
  type: 'section',
  title: 'Indexadores',
  fieldName: 'profitabilityType',
  options: [
    { label: 'Prefixado', value: 'PRE' },
    { label: 'Pós fixado(CDI)', value: 'POS' },
    { label: 'Inflação', value: 'INFLACAO' },
  ],
};
